<template>
  <section class="flex section dashboard m-a-between">
    <div class="col-left">
      <div class="absolute-wrapper">
        <user-profile :user="user"></user-profile>
        <recent-listens :tracks="recentTracks"></recent-listens>
      </div>
    </div>
    <div class="col-right flex">
      <div class="solid-background box-shadow">
        <artist-list :artists="topArtists"></artist-list>
        <recommendet-tracks :tracks="recommendetTracks"></recommendet-tracks>
      </div>
    </div>
  </section>
</template>

<script>
import userProfile from './UserProfile';
import artistList from './ArtistList';
import recentListens from './RecentListens';
import recommendetTracks from './RecommendetTracks';
export default {
  name: 'dashboard',
  props: ['user', 'topArtists', 'recentTracks', 'recommendetTracks'],
  components: {userProfile, artistList, recentListens, recommendetTracks}
}
</script>

<style scoped>
  .dashboard {
    width: 100%;
    align-items: stretch;
    height: 100%;
  }
  .col-left {
    width: 25%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }
  .col-right {
    width: 75%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }
  .solid-background {
    padding: 2rem;
    padding-right: calc(2rem + 16px);
    background: linear-gradient(-45deg, hsla(37, 100%, 60%, 1), hsla(37, 100%, 70%, 1));
    width: calc(100% + 16px);
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    height: 100%;
    overflow-y: scroll;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .absolute-wrapper {
    overflow-y: scroll;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: calc(100% + 16px);
    background: #fff;
    border-radius: 10px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  @media screen and (max-width: 1024px) {
    .absolute-wrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-start;
    }
    .dashboard
    .col-left,
    .col-right {
      height: initial;
    }
    .col-left,
    .col-right {
      width: 100%;
    }
    .solid-background,
    .absolute-wrapper {
      height: initial;
      position: relative;
      overflow: initial;
    }
  }
</style>